import { useEffect, useRef } from 'react';

import { useSetChatbotError, ChatbotError } from 'state/chatbot-error';
import { useHasAgentConversationStarted } from 'state/hasAgentConversationStarted';

export const useSubscribeChatbotQueryErrorAndSetState = (
  enabled,
  isInitialQueryError,
  isChatbotQueryError,
) => {
  const firstInteractionQueryErrorHappendedRef = useRef(false);
  const hasAgentConversationStarted = useHasAgentConversationStarted();

  const setChatbotError = useSetChatbotError();

  /**
   * Set initial chatbot context query error state
   */
  useEffect(() => {
    if (isInitialQueryError && hasAgentConversationStarted) {
      setChatbotError(ChatbotError.InChatInteractionError);
    } else if (isInitialQueryError) {
      setChatbotError(ChatbotError.WelcomeError);
    }
  }, [isInitialQueryError, setChatbotError, hasAgentConversationStarted]);

  /**
   * Set chatbot interaction query error
   */
  useEffect(() => {
    if (isChatbotQueryError && hasAgentConversationStarted) {
      setChatbotError(ChatbotError.InChatInteractionError);
    } else if (isChatbotQueryError) {
      if (!firstInteractionQueryErrorHappendedRef.current) {
        setChatbotError(ChatbotError.FirstInteractionError);

        firstInteractionQueryErrorHappendedRef.current = true;
      } else {
        setChatbotError(ChatbotError.NextInteractionError);
      }
    } else {
      // if no error, need to clear error state
      setChatbotError('');
    }
  }, [isChatbotQueryError, setChatbotError, hasAgentConversationStarted]);
};
